import React from 'react';
import { handleForgetPassword } from '../../../api/Auth';
import {
    Button,
} from "@mui/material";

const ResendResetCode = ({email}) => {
    const oneMin = 60;
    const timeoutId = React.useRef(null);
    const [timer, setTimer] = React.useState(localStorage.getItem("timer") || oneMin);
    const [isTicking, setIsTicking] = React.useState( timer < oneMin || false);
    const countTimer = React.useCallback(() => {
        if (timer <= 0) {
            localStorage.removeItem("timer");
            setIsTicking(false);
        } else {
        setTimer(timer - 1);
            localStorage.setItem("timer", timer);
        }
    }, [timer]);
    React.useEffect(() => {
        timeoutId.current = window.setTimeout(countTimer, 1000);
        // cleanup function
        return () => window.clearTimeout(timeoutId.current);
    }, [timer, countTimer]);

    async function handleClick () {
        if(!isTicking){
            await handleForgetPassword(email);
            setIsTicking(true);
            setTimer(oneMin);
        }
    }

    return (
        <Button
            disableElevation
            fullWidth
            size="large"
            onClick={handleClick}
            variant="outlined"
            disabled={isTicking}
            style={{
                backgroundColor: "white",
            }}
        >
                { isTicking ? `Resend Code (${timer}s)`: "Resend Code" } 
        </Button> 
    )
}
export default ResendResetCode;